import angular from "angular";

angular
    .module('app')
    .component('clientEmployeesImportForm', {
        template: require('./clients-employees-import-form.html'),
        controller: ['$http', 'Upload', 'notifier', '$scope', '$uibModal', 'moment', controller],
        bindings: {
            organization: '<',
            client: '<',
            fields: '<',
        }
    });

function controller($http, Upload, notifier, $scope, $uibModal, moment) {

    const $ctrl = this;

    $ctrl.file = null;

    $ctrl.items = null;

    $ctrl.uploadFile = () => {
        $ctrl.loading = true;

        Upload.upload({
            url: `/clients/${$ctrl.client.id}/employees/parse-excel`,
            data: {file: $ctrl.file}
        }).then(
            res => {
                $ctrl.loading = false;
                $ctrl.items = res.data;

                $ctrl.items.forEach(item => {
                    item.fieldValues = {};

                    $ctrl.fields.forEach(field => {
                        const fieldValue = item.field_values.find(v => v.field_id === field.id);
                        item.fieldValues[field.id] = fieldValue ? fieldValue.value : null;
                    });
                })
            },
            err => {
                $ctrl.loading = false;
                notifier.errorResponseNotify(err);
            }
        );
    };

    $ctrl.openForm = (emp) => {
        $uibModal
            .open({
                component: 'employeeImportInfo',
                resolve: {
                    employee() {
                        return emp;
                    },
                    fields() {
                        return $ctrl.fields;
                    }
                },
                size: 'lg',
            })
            .result
            .then(res => {

            })
            .catch(err => {

            });
    };

    $ctrl.confirm = async function () {
        $ctrl.confirmLoading = true;

        $ctrl.items.forEach(item => {
            item.status = 'waiting';
        });

        for (let i = 0; i < $ctrl.items.length; i++) {
            const emp = $ctrl.items[i];

            const params = {
                first_name: emp.first_name,
                last_name: emp.last_name,
                patronymic: emp.patronymic,
                gender: emp.gender,
                birth_date: emp.birth_date ? moment(emp.birth_date, 'DD.MM.YYYY').format('YYYY-MM-DD') : null,
                citizenship_code: emp.citizenship_code,
                iin: emp.iin,
                first_name_en: emp.first_name_en,
                last_name_en: emp.last_name_en,
                phone_number: emp.phone_number,
                email: emp.email,
                documents: emp.documents.filter(v => !!v.number).map(v => {
                    return {
                        type: v.type,
                        number: v.number,
                        issue_date: v.issue_date ? moment(v.issue_date, 'DD.MM.YYYY').format('YYYY-MM-DD') : null,
                        expire_date: v.expire_date ? moment(v.expire_date, 'DD.MM.YYYY').format('YYYY-MM-DD') : null,
                    };
                }),
                field_values: emp.field_values,
            };

            try {
                if (emp.id) {
                    await $http.post(
                        `/clients/${$ctrl.client.id}/employees/${emp.id}`,
                        params
                    )
                } else {
                    await $http.post(
                        `/clients/${$ctrl.client.id}/employees`,
                        params
                    );
                }

                emp.status = 'success';
            } catch (err) {
                emp.status = 'error';
                emp.errorMessages = err.data.messages;
            }

            $scope.$apply();
        }
    };

    $ctrl.showErrors = function (client) {
        $uibModal.open({
            component: 'clientImportErrorMessages',
            resolve: {
                client() {
                    return client;
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/client-employees-import-form/client-employees-import-form.js